(function($) {
  console.log("featured-events-carousel");

  var $carousel = $(".featured-events-carousel__slides");

  $carousel.slick({
    appendDots: $('#featured-events-carousel__dots'),
    dots: true,
    infinite: false,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: false,
    appendArrows: $('#featured-events-carousel__arrows'),
    adaptiveHeight: true,
    // Part of the hack in reversing the slider.
    nextArrow:
      '<button class="reset carousel__next-arrow slick-prev"><span aria-hidden="true" class="icon-chev-right"><span class="sr-only">Arrow Icon</span></span><div class="sr-only">Next Course</div></button>',
    prevArrow:
      '<button class="reset carousel__prev-arrow slick-next"><span aria-hidden="true" class="icon-chev-left"><span class="sr-only">Arrow Icon</span></span><div class="sr-only">Previous Course</div></button>'
  });
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/featured-events-carousel.js